//#region DevExtreme Imports

import 'devextreme/ui/button'

//#endregion

import { IMRBaseComponent } from "../../../../../../../common/base"

import { OPERATOR_NOTIFICATIONS_SERVICE_NAME } from "../../../../../../../../services/operator"

import { OperatorDetailsNotificationsPageController } from "./operator-details.notifications.page.controller"

//#region Asset Imports

import './operator-details.notifications.page.scss'
import * as TEMPLATE from './operator-details.notifications.page.tpl.html'

//#endregion


export const COMPONENT_NAME: string = 'operatorDetailsNotificationsPage'

export class OperatorDetailsNotificationsPageComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: OperatorDetailsNotificationsPageController,
            services: [OPERATOR_NOTIFICATIONS_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}
